var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClassificationLower(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 306,
    height: 205,
    viewBox: "0 0 306 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M153 2.5C65.963 2.5 3 44.1667 3 44.1667C3 44.1667 39.4198 202.5 153 202.5C266.58 202.5 303 44.1667 303 44.1667C303 44.1667 240.037 2.5 153 2.5Z",
    stroke: "#2CAAE2",
    strokeWidth: 5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9229 58.5H295.923",
    stroke: "#86868B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "8 8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M153.923 10.3125V197.813",
    stroke: "#86868B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "8 8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassificationLower);
export default __webpack_public_path__ + "static/media/classificationLower.c6093c07bc24cc3fa4850f5ec6c3399c.svg";
export { ForwardRef as ReactComponent };